import React from 'react';
import {ALIS} from "../constants";
import {calculateCurrency, getPrice} from "../commons";

class CurrencyUnit extends React.Component {

    state = {
        ekleme: 0,
        asagi_yuvarla: false,
        yukari_yuvarla: false,
        tam_yuvarla: false,
    }

    componentWillMount() {
        const {data, name, type} = this.props;
        if (data && data[name] && data[name][type]) {
            this.setState({...data[name][type]})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            if (nextProps.data && nextProps.data[nextProps.name] && nextProps.data[nextProps.name][nextProps.type]) {
                this.setState({...nextProps.data[nextProps.name][nextProps.type]})
            }
        }
    }


    changeValue = (key, value) => {
        let temp = {}
        if (key === 'asagi_yuvarla') {
            if (this.state.asagi_yuvarla && !value) {
                temp = {asagi_yuvarla: false}
            } else {
                temp = {asagi_yuvarla: value, yukari_yuvarla: !value}
            }
        } else if (key === 'yukari_yuvarla') {
            if (this.state.yukari_yuvarla && !value) {
                temp = {yukari_yuvarla: false}
            } else {
                temp = {asagi_yuvarla: !value, yukari_yuvarla: value}
            }
        } else {
            temp = {[key]: value}
        }
        this.setState({...this.state, ...temp}, this.onChange)
    }

    onChange = () => {
        const {data, name, type} = this.props;
        this.props.onChange({...data[name], [type]: {...this.state}})
    }

    render() {
        const {hasAltin, type, data, name} = this.props;
        const currency = getPrice(name);

        return (
            <td>
                <div className="left_col">
                    <table>
                        <tbody>
                        <tr>
                            <td>{this.props.title} alış fiyatına ({currency[type]})</td>
                            <td><input type="number" style={{margin: '0 10px'}} placeholder="miktar" value={this.state.ekleme} onChange={(e) => {
                                this.changeValue('ekleme', e.target.value)
                            }}/></td>
                            <td>ekle</td>
                        </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                        <tr>
                            <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.asagi_yuvarla} onChange={(e) => {
                                this.changeValue('asagi_yuvarla', e.target.checked)
                            }}/></td>
                            <td>AŞAĞI ,</td>
                            <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.yukari_yuvarla} onChange={(e) => {
                                this.changeValue('yukari_yuvarla', e.target.checked)
                            }}/></td>
                            <td>YUKARI ,</td>
                            <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.tam_yuvarla} onChange={(e) => {
                                this.changeValue('tam_yuvarla', e.target.checked)
                            }}/></td>
                            <td>TAM yuvarla</td>
                        </tr>
                        </tbody>
                    </table>
                    <hr/>
                    <span className="result">Sonuç = {calculateCurrency(currency, data[name], type)}</span>
                </div>
            </td>
        )
    }
}

export default CurrencyUnit


// WEBPACK FOOTER //
// ./src/component/CurrencyUnit.js